/*
 * Copyright (C) 2021 SailPoint Technologies, Inc. All rights reserved.
 */

export { DashboardLayoutComponent } from './dashboard-layout.component';
export { DashboardLayoutModule } from './dashboard-layout.module';
